import GLightbox from 'glightbox'

/**
 * Opens article photos (links with the "glightbox" class) in a lightbox instead of leaving the page.
 * Call it after Vue has mounted, because Vue replaces the server-rendered DOM inside #app.
 */
export function initLightbox (): ReturnType<typeof GLightbox> | null {
  if (document.querySelector('.glightbox') === null) {
    return null
  }

  return GLightbox({ selector: '.glightbox', touchNavigation: true, loop: false })
}
